var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "container position-sticky position-top-0 zindex-4 bg-white pb-1 mb-2 shadow"
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("b-badge", { attrs: { variant: "light-warning mb-1" } }, [
              _vm._v(" ACT-" + _vm._s(_vm.activity.id) + " ")
            ]),
            _c("b-badge", { attrs: { variant: "light-primary float-right" } }, [
              _vm._v(
                " " + _vm._s(_vm._f("dateFormat")(_vm.activity.createdAt)) + " "
              )
            ]),
            _c("br"),
            _c("b-badge", { attrs: { variant: "light-primary" } }, [
              _vm._v(" " + _vm._s(_vm.activity.referenceElementType) + " ")
            ]),
            _vm.activity.referenceId
              ? _c(
                  "b-badge",
                  { staticClass: "ml-3", attrs: { variant: "light-success" } },
                  [
                    _vm._v(" # "),
                    _c("feather-icon", { attrs: { icon: "FileTextIcon" } }),
                    _vm._v(
                      " " + _vm._s(_vm.activity.referenceElementNumber) + " "
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }